
import './Home.scss'
import { useAuth } from 'react-oidc-context';
import { hasResourceRole } from '../../common/utils/tokenUtil';
import { getTicketRole } from '../ticketCtrl/ticketDetails/role-processor/permission-config';
import { Dashboard } from '../dashboard/Dashboard';
import { createPageTestId } from '../../common/utils/testIds';


export const Home = () => {
  const auth = useAuth();

  return (<>
    <div className="content" data-testid={createPageTestId('home')}>
      {
      (auth.isAuthenticated && getTicketRole(auth) !== "unauthorized") ?
        <Dashboard /> :
        <NotAuthorized />
      }
    </div>
  </>)
}

/********************************************************************************************************
 * 
 * @returns 
*********************************************************************************************************/
function NotAuthorized(){
  return (
    <p className='notAuthorized'>
      Your account has been successfully created. You are currently unable to access this application because a user role has not been assigned to you. 
      A user role will be assigned by an administrator shortly and you will receive an email confirmation. Please direct questions to one of the following: your supervisor, your Area's Regional Data Administrator, 
      your Wildfire Management Branch contact, or Wildfire Applications Support via <a href="mailto:wildfire.applications@gov.ab.ca"> wildfire.applications@gov.ab.ca</a> or +1 780-427-8100
    </p>
  );
}
    